module.exports = __webpack_public_path__ + "img/account--avatar.ec8dc79e.svg";